import { connect } from 'react-redux'
import { cloneDeep } from 'lodash';

import Map from './Map';

const matches = {
  'SpeedLimits': 'SpeedLimit',
  'Curvatures': 'Curvature',
  'Slopes': 'Slope'
}

const filters = {
    'EnhancedData': (data, excludes) => {
      const types = excludes.map(item => matches[item])
      data.geojson.features = data.geojson.features.filter(item => types.indexOf(item.properties.type) !== -1);
      data.adasis.features = [];
      return data;
    },
    
    'Adasis': (data, excludes) => {
      const types = excludes.map(item => item.toUpperCase());
      data.adasis.features = data.adasis.features.filter(item => item.geometry.type !== 'Point' || types.indexOf(item.properties.type) !== -1);
      data.geojson.features = [];
      return data;
    }
}

const mapStateToProps = (state) => {
    const stateCopy = cloneDeep(state);

    const mode = stateCopy.mapData.mode;
    let { data, filter, sliderValue } = stateCopy.mapData;
    const filterFn = filters[mode];

    if (mode === 'Adasis') {
      const positions = data.adasis.features.filter(item => item.properties.type === 'POSITION');
      const index = Math.floor(positions.length * (sliderValue / 100.0));
      const position = positions[index];

      data.adasis.features = data.adasis.features.filter(item => item.geometry.type !== 'Point' || 
                                                                 (item.properties.eventTimestamps.createdTimestamp &&
                                                                  item.properties.eventTimestamps.sentTimestamp));
      data.adasis.features = data.adasis.features.filter(item => 
          item.geometry.type !== 'Point' || 
          ((item.properties.eventTimestamps.deletedTimestamp ?
                item.properties.eventTimestamps.deletedTimestamp >= position.properties.eventTimestamps.deletedTimestamp :
                item.properties.eventTimestamps.sentTimestamp + 60000000000 >= position.properties.eventTimestamps.deletedTimestamp) &&
          item.properties.eventTimestamps.sentTimestamp <= position.properties.eventTimestamps.sentTimestamp));

      if (position.properties.mpp) {
        data.mpp = position.properties.mpp;
      }

    }

    return { data: filterFn(data, filter) };
}

const mapDispatchToProps = ({})

const FilteredMap = connect(mapStateToProps, mapDispatchToProps)(Map)

export default FilteredMap;